module.exports = __webpack_public_path__ + "img/SES_8820.e21a5838.jpg";